import { render } from "./AuthLayout.vue?vue&type=template&id=52d80d28&scoped=true&ts=true&lang=pug"
import script from "./AuthLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AuthLayout.vue?vue&type=style&index=0&id=52d80d28&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d80d28"]])

export default __exports__